<div class="mon-dialog-header">
    <page-header
            [header]="dialogHeader"
            [subHeaderTooltipEnable]="false"
            subHeader="<a href='{{link.url}}' target='_blank' class='text-link'>{{link.url}}</a>"
    >
        <page-header-content>
            <div class="row mon-dialog-delay-fadein">
                <div class="col-48 inner-r-large outer-t-mini text-right">
                    <csv-export-button [exports]="exports"></csv-export-button>
                    <table-search [minSearchLength]="3"
                                  class="inline-block outer-r-small text-v-middle"
                                  theme="grey-theme"
                                  placeholderTxt="{{ 'Search...' | translate }}"
                                  [model]="search"
                                  (getPage)="onSearch($event)">
                    </table-search>
                </div>
            </div>
        </page-header-content>
    </page-header>
</div>
<div class="mon-dialog-body">
    <div class="card panel-monsido-card outer-t outer-r outer-l">
        <div class="card-body">
            <div class="row">
                <div class="col-md-48 col-lg-48 col-48">
                    <table-container
                            [collection]="pages"
                            (onPageChange)="onPageChange($event)"
                            (onPerPageChange)="onPageSizeChange($event)"
                            [progress]="promise"
                            class="pages-table-wrapper"
                    >
                        <table class="table table-hover table-fixed">
                            <thead>
                            <tr>
                                <th class="col-sm-20 col-md-20 col-lg-20"><span class="inner-l-small" translate>Title and URL</span></th>
                                <th class="col-sm-4 col-md-4 col-lg-3" *ngIf="showUnwantedViolations" translate>Unwanted violations</th>
                                <th class="col-sm-4 col-md-4 col-lg-3" *ngIf="showNormalViolations" translate>Normal violations</th>
                                <th class="col-sm-3 col-md-4 col-lg-4"
                                    monTableSort
                                    [monSortDirection]="currentSort.direction"
                                    monSortBy="hits"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    *ngIf="viewsColumIsAvailable"
                                    >{{ 'Views' | translate }}</th>
                                <th class="col-sm-4 col-md-4 col-lg-6">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages; let i = index; trackBy: trackByFn">
                                <td class="text-ellipsis">
                                    <div class="inner-l-small text-ellipsis">
                                        <url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                                [title]="page.title"
                                                [subTarget]="active"
                                                [target]="'page-details-section-inventory'"
                                                [url]="page.url"
                                                [page]="page"
                                                [active]="false" >
                                        </url-title-page-details>
                                        <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                    [document]="page"
                                                                    [title]="page.title"
                                                                    [url]="page.url"
                                                                    [active]="true"
                                                                    [target]="'inventory'"
                                                                    [subTarget]="active">
                                        </url-title-document-details>
                                    </div>
                                </td>
                                <td *ngIf="showUnwantedViolations">
                                    <icon-button
                                            faIcon="fa-gavel"
                                            [number]="page.error_searches_count"
                                            positive="text-info"
                                            neutral="text-neutral-misspelling"
                                            [changeTextColor]="false">
                                    </icon-button>
                                </td>
                                <td *ngIf="showNormalViolations">
                                    <icon-button
                                            faIcon="fas fa-bug"
                                            [number]="(page.searches_count - page.error_searches_count)"
                                            positive="text-danger"
                                            negative="negative"
                                            neutral="text-neutral-misspelling"
                                            [changeTextColor]="false">
                                    </icon-button>
                                </td>
                                <td *ngIf="viewsColumIsAvailable" class="text-v-middle">
                                    <visits [visits]="page.hits" [title]="page.title" [totalVisits]="pages.pageHits"></visits>
                                </td>

                                <td class="text-right text-v-middle" [attr.aria-label]="'Page details' | translate">
                                    <div class="inner-r-small">
                                        <table-page-details
                                                *ngIf="page.type === 'html'"
                                                ngbTooltip="{{ 'Open page details' | translate }}"
                                                [triggers]="'focus hover'"
                                                [subTarget]="active"
                                                [target]="'page-details-section-inventory'"
                                                class="list-inline inline-block"
                                                [page]="page">
                                        </table-page-details>
                                        <table-document-details
                                                *ngIf="page.type !== 'html'"
                                                ngbTooltip="{{ 'Open document details' | translate }}"
                                                [triggers]="'focus hover'"
                                                target="inventory"
                                                [subTarget]="active"
                                                class="list-inline inline-block"
                                                [document]="page"
                                                (callBack)="onPageDetailsClose()">
                                        </table-document-details>
                                    </div>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    </div>
</div>
